module.exports = __webpack_public_path__ + "src/assets/img/icon_0.a6ad8a13.svg";